<template>
  <div class="p-6 bg-white/60 rounded-xl min-h-screen">
    <!-- Header Section -->
    <div class="flex justify-between items-center mb-2">
      <h5 class="text-md font-bold text-gray-800 inline-block transition-all duration-500">
        <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
          ایرانی
        </span>
      </h5>
      <div class="flex gap-3">
        <button
            @click="refreshPacking"
            class="p-2 mr-2  bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-50 transform hover:scale-105"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-gray-600" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Filter Section -->
    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-2 shadow-sm border border-gray-100">
      <div class="flex flex-wrap items-center gap-2">
        <!-- Search -->
        <div class="relative w-32">
          <input
              v-model="filters.title__icontains"
              placeholder="عنوان"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.factor_number__icontains"
              placeholder="شماره فاکتور"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <select
              @change="applyFilters"
              v-model="filters.supplier"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
          >
            <option value=''>تامین کننده</option>
            <option
                v-for="supplier in suppliers"
                :key="supplier.id"
                :value="supplier.id"
            >
              {{ supplier.name }}
            </option>
          </select>
        </div>
        <div class="relative w-32">
          <select
              @change="applyFilters"
              v-model="filters.currency"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
          >
            <option value=''> ارز</option>
            <option
                v-for="currency in currencies"
                :key="currency.id"
                :value="currency.id"
            >
              {{ currency.name }}
            </option>
          </select>
        </div>

        <div class="flex gap-1">
          <button
              @click="resetFilters"
              class="p-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="حذف فیلترها"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>

          <button
              @click="applyFilters"
              class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="اعمال فیلتر"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="flex justify-center items-center h-64">
      <div class="flex flex-col items-center gap-2">
        <svg class="animate-spin h-10 w-10 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
             viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-gray-600">در حال بارگذاری...</span>
      </div>
    </div>

    <!-- Empty State -->
    <div v-else-if="packages.length === 0"
         class="flex flex-col items-center justify-center h-64 bg-white/70 rounded-xl p-6 text-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24"
           stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <p class="text-gray-500 text-lg">پکینگی یافت نشد</p>
      <p class="text-gray-400 mt-2">با تغییر فیلترها دوباره امتحان کنید</p>
    </div>

    <div v-else class="grid grid-cols-1  mb-6">
      <div
          v-for="(packageItem, index) in packages"
          :key="packageItem.id"
          class="bg-blue-100 rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 border border-gray-100"
      >
        <div class="grid grid-cols-2  md:grid-cols-6 gap-2 bg-gray-900 p-5 rounded-t-lg">
          <div class="flex flex-col">
            <span class="text-xs text-gray-100 font-bold">عنوان</span>
            <span class="text-sm font-medium text-blue-200">{{ packageItem.title || 'پکینگ چینی' }}</span>
          </div>
          <div class="flex flex-col">
            <span class="text-xs text-gray-100 font-bold">شماره فاکتور</span>
            <span class="text-sm font-medium mt-1 text-blue-200">{{ packageItem.factor_number || '---' }}</span>
          </div>
          <div class="flex flex-col">
            <span class="text-xs text-gray-100 font-bold">تاریخ ثبت</span>
            <span class="text-sm font-medium mt-1 text-blue-200">{{ packageItem.registration_date }}</span>
          </div>
          <div class="flex flex-col col-span-2 ">
            <span class="text-xs text-gray-100 font-bold">توضیحات</span>
            <span class="text-sm font-medium mt-1 text-blue-200">{{ packageItem.explanation || 'بدون توضیح' }}</span>
          </div>
          <div class="flex flex-col  justify-end items-end">
            <button @click="goDetail(packageItem.id)"
                    class="p-2 text-gray-600 hover:text-gray-800 hover:bg-blue-400 rounded-full transition-colors duration-200 left-1"
                    title="جزییات">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="white">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"/>
              </svg>
            </button>
          </div>
        </div>
        <div v-for="delivery in packageItem.deliveries" :key="delivery.id"
             class="bg-gray-800 m-1 rounded-xl border border-gray-700 shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
          <div class="p-3">
            <!-- Delivery Details - Single Line Layout -->
            <div class="grid grid-cols-6 gap-4 mb-5">
              <div class="flex items-center">
                <div class="bg-blue-900/30 p-2 rounded-lg ml-2">
                  <i class="fas fa-calendar text-blue-400"></i>
                </div>
                <div>
                  <p class="text-gray-400 text-xs">تاریخ تحویل</p>
                  <p class="text-white font-medium">{{ delivery.delivery_date }}</p>
                </div>
              </div>

              <div class="flex items-center">
                <div class="bg-purple-900/30 p-2 rounded-lg ml-2">
                  <i class="fas fa-file-alt text-purple-400"></i>
                </div>
                <div>
                  <p class="text-gray-400 text-xs">شماره سند</p>
                  <p class="text-white font-medium">{{ delivery.document_number }}</p>
                </div>
              </div>

              <div class="flex items-center">
                <div class="bg-cyan-900/30 p-2 rounded-lg ml-2">
                  <i class="fas fa-cube text-gray-400"></i>
                </div>
                <div>
                  <p class="text-gray-400 text-xs">تعداد کارتون تحویل شده</p>
                  <p class="text-white font-medium">{{ delivery.total_boxes }}</p>
                </div>
              </div>

              <div class="flex items-center">
                <div class="bg-gray-700 p-2 rounded-lg ml-2">
                  <i class="fas fa-box text-cyan-400"></i>
                </div>
                <div>
                  <p class="text-gray-400 text-xs">تعداد کالا تحویل شده</p>
                  <p class="text-white font-medium">{{ delivery.total_delivered_quantity }}</p>
                </div>
              </div>

              <div class="flex items-center">
                <div class="bg-blue-900/30 p-2 rounded-lg ml-2">
                  <i class="fas fa-user text-blue-400"></i>
                </div>
                <div>
                  <p class="text-gray-400 text-xs">راننده</p>
                  <p class="text-white font-medium">{{ delivery.driver_name }}</p>
                </div>
              </div>
              <div class="flex flex-col justify-end items-end">
                <div>
                  <div class="m-1">
                    <p class="text-xs bg-blue-500/50 text-blue-100 p-1 rounded text-center">
                      تعداد آیتم های تحویل :
                      <span class="text-white text-md"> {{ delivery.items_count }}
                      ردیف
                      </span>
                    </p>
                    <p class="text-xs bg-green-500/50 text-green-100 p-1 rounded text-center">
                      تعداد آیتم های انتقال داده شده :
                      <span class="text-white text-md"> {{ delivery.inserted_count }}
                      ردیف
                      </span>
                    </p>
                    <p class="text-xs bg-pink-600/50 text-pink-300 p-1 rounded text-center" v-if="delivery.pending_insert>0">
                      تعداد آیتم های انتقال داده نشده :
                      <span class="text-white text-md"> {{ delivery.pending_insert }}
                      ردیف
                      </span>
                    </p>
                    <p class="text-xs bg-pink-600/50 text-pink-300 p-1 rounded text-center" v-if="delivery.pending_insert == 0">
                      انتقال تکمیل شده
                    </p>
                    <p class="text-xs bg-green-500/50 text-green-100 p-1 rounded text-center">
                      تعداد تایید شده از مدیر :
                      <span class="text-white text-md"> {{ delivery.verified_count }}
                      ردیف
                      </span>
                    </p>
                    <p class="text-xs bg-red-600/50 text-red-300 p-1 rounded text-center" v-if="delivery.pending_not_verified > 0">
                      آیتم های تایید نشده از مدیر :
                      <span class="text-white text-md"> {{ delivery.pending_not_verified }}
                      ردیف
                      </span>
                    </p>

                  </div>

                  <div class="m-1 mt-3" v-if="delivery.pending_not_verified > 0">
                    <button
                        @click="goVerify(delivery.id)"
                        v-if="!delivery.all_items_verified"
                        class="p-2 w-full text-green-300  text-center text-sm hover:text-green-400 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors duration-200 left-1">
                      تایید مدیر
                    </button>
                  </div>
                  <div class="m-1 mt-3" v-if="delivery.all_items_verified">
                    <span
                        @click="goVerify(delivery.id)"
                        class="cursor-pointer p-2 w-full text-orange-300 text-sm text-center  rounded-lg transition-colors duration-200 left-1"><i class="fa fa-check"></i>
                      تایید شده از سمت مدیر
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div v-if="packages.length > 0"
         class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-4 border border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
      <div class="text-sm text-gray-600">
        نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
        {{ Math.min(currentPage * itemsPerPage, totalPackages) }} از
        {{ totalPackages }} پکینگ
      </div>
      <div class="flex gap-1">
        <button
            @click="prevPage"
            :disabled="currentPage === 1"
            class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
        <button
            v-for="page in visiblePages"
            :key="page"
            @click="goToPage(page)"
            class="p-2 text-center border border-gray-200 rounded-full transition-colors duration-200"
            :class="{
            'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
            'bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
            'cursor-default': page === '...'
          }"
            :disabled="page === '...'"
        >
          {{ page }}
        </button>
        <button
            @click="nextPage"
            :disabled="currentPage * itemsPerPage >= totalPackages"
            class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            :class="{ 'opacity-50 cursor-not-allowed': currentPage * itemsPerPage >= totalPackages }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Notification -->
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">
        <div
            class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"/>
          </svg>
        </div>
        <div class="mr-3 text-sm font-normal pr-2"> با موفقیت ثبت شد</div>
        <button @click="showNotification = false"
                class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'DomesticNeedVerifyDeliver',
  data() {
    return {
      showNotification: false,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: true,
      packages: [],
      totalPackages: 0,
      currentPage: 1,
      activePricing: [],
      itemsPerPage: 5,
      filters: {
        title__icontains: '',
        factor_number__icontains: '',
        supplier: '',
        currency: '',
      },
      categories: [],
      brands: [],
      currencies: [],
      suppliers: [],
      productSelected: null,
      showProductStoreHandle: false
    }
  },
  computed: {
    visiblePages() {
      const totalPages = Math.ceil(this.totalPackages / this.itemsPerPage)
      const range = 1
      const pages = []

      if (totalPages <= 1) return [1]

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },
  methods: {
    calculateRowIndex(index) {
      return (this.currentPage - 1) * this.itemsPerPage + index + 1;
    },
    viewDetails(packageItem) {
      alert(`جزئیات بسته: ${packageItem.name}\nشناسه: ${packageItem.id}\nتعداد آیتم‌ها: ${packageItem.items_count}`);
    },
    downloadFile(packageItem) {
      if (!packageItem.uploaded_file) {
        this.showNotificationMessage('فایل آپلود شده موجود نیست', 'error');
        return;
      }

      this.showNotificationMessage('در حال دانلود فایل...', 'success');
      // شبیه‌سازی دانلود فایل
      setTimeout(() => {
        this.showNotificationMessage('فایل با موفقیت دانلود شد', 'success');
      }, 1500);
    },
    exportToExcel() {
      this.showNotificationMessage('در حال آماده‌سازی خروجی Excel...', 'success');
      // شبیه‌سازی تولید فایل Excel
      setTimeout(() => {
        this.showNotificationMessage('خروجی Excel با موفقیت تولید شد', 'success');
      }, 2000);
    },

    isActive(product) {
      return this.activePricing.some(p => p === product);
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    handleDone(product) {
      this.request({
        url: this.endpoint('store_handle/productStoreInventoryHandleCreate'),
        method: 'post',
        data: product,
        success: (data) => {
          this.showNotificationMessage()
          this.fetchPacking()
        },
      })
    },
    fetchPacking() {
      this.loading = true

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      }

      Object.keys(params).forEach(key => {
        if (params[key] === '') {
          delete params[key]
        }
      })

      this.request({
        url: this.endpoint('entrance/domesticEntrancePackageHasDeliveries/all'),
        method: 'get',
        params,
        success: (data) => {
          this.packages = data.results
          this.totalPackages = data.count
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchPacking()
    },
    goInsert(id) {
      this.$router.push(`/panel/deliverInsert/${id}`)
    },

    resetFilters() {
      this.filters = {
        title__icontains: '',
        factor_number__icontains: '',
        supplier: '',
        currency: '',
      }
      this.applyFilters()
    },

    refreshPacking() {
      this.fetchPacking()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchPacking()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalPackages) {
        this.currentPage++
        this.fetchPacking()
      }
    },
    goDetail(id) {
      this.$router.push(`/panel/pendingPackageDomesticDetail/${id}`)
    },
    goVerify(id) {
      this.$router.push(`/panel/domesticDeliverInsertedWaitForVerify/${id}`)
    },
    goDeliver(id) {
      this.$router.push(`/panel/DeliverDomesticPackage/${id}`)
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchPacking()
      }
    },
    productStoreHandle(product) {
      this.selectedProduct = product
      this.showProductStoreHandle = true
    },

    active(product) {
      const index = this.activePricing.indexOf(product);
      if (index > -1) {
        this.activePricing.splice(index, 1);
      } else {
        this.activePricing.push(product);
      }
    },
    calculate_discount(price, discount) {
      return price - (price / 100 * discount)
    },
    closeProductStoreHandle() {
      this.selectedProduct = null
      this.showProductStoreHandle = false
    },
    fetchCurrency() {
      this.request({
        url: this.endpoint('main/currency'),
        method: 'get',
        success: (data) => {
          this.currencies = data
        }
      })
    },
    fetchSuppliers() {
      this.request({
        url: this.endpoint('main/supplier'),
        method: 'get',
        success: (data) => {
          this.suppliers = data
        }
      })
    },
  },
  mounted() {
    this.fetchSuppliers()
    this.fetchCurrency()
    this.fetchPacking()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.bg-secondary {
  background-color: #424242;
}

/* Animation for notification */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>